import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    callouts: {
      genericError: {
        description:
          "You haven't been charged. Please try again and if the problem persists, please contact us.",
        title: 'The transfer failed',
      },
      insufficientFunds: {
        description:
          'The transfer failed due to an insufficient balance. Please credit your account and try again.',
        title: 'The transfer failed',
      },
      processing: {
        description:
          'Transfers are usually processed instantly, but can take up to 24 hours.',
        title: 'Processing the transfer',
      },
    },
  },
  fr: {
    callouts: {
      genericError: {
        description:
          'Vous n’avez pas été débité. Veuillez réessayer et si le problème persiste, contactez-nous.',
        title: 'Le virement a échoué',
      },
      insufficientFunds: {
        description:
          "Le virement a échoué en raison d'un solde insuffisant. Veuillez créditer votre compte puis réessayez.",
        title: 'Le virement a échoué',
      },
      processing: {
        description:
          'Le traitement du virement est généralement instantané mais peut prendre jusqu’à 24h.',
        title: 'Traitement du virement en cours',
      },
    },
  },
} as const);

export default locales;
